import { InternalLink as Link } from "components";
import {ROUTES} from 'routes';

export const ContactUs = ({ text = "Contact us", lower = false, children = null }) => (
  <Link to={ROUTES.contact}>{children ? children : lower ? text.toLowerCase() : text}</Link>
);
